import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './contact-form3.css'

const ContactForm3 = (props) => {
  return (
    <div
      id={props.contactForm3Id}
      className={`contact-form3-contact9 thq-section-padding ${props.rootClassName} `}
    >
      <div className="thq-section-max-width thq-flex-row contact-form3-max-width">
        <div className="contact-form3-container1">
          <img
            alt={props.imageAlt1}
            src="/de42bb9cf5-commercial-buildings-4-shmpu.avif"
            className="contact-form3-image"
          />
          <div className="contact-form3-contact-info thq-flex-column">
            <div className="contact-form3-row1 thq-flex-row">
              <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                <path d="M854 342v-86l-342 214-342-214v86l342 212zM854 170q34 0 59 26t25 60v512q0 34-25 60t-59 26h-684q-34 0-59-26t-25-60v-512q0-34 25-60t59-26h684z"></path>
              </svg>
              <span className="thq-body-small"> <a href="mailto:info@omshashvath.com"></a>info@omshashvath.com</span>
            </div>
            <div className="contact-form3-row2 thq-flex-row">
              <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                <path d="M282 460q96 186 282 282l94-94q20-20 44-10 72 24 152 24 18 0 30 12t12 30v150q0 18-12 30t-30 12q-300 0-513-213t-213-513q0-18 12-30t30-12h150q18 0 30 12t12 30q0 80 24 152 8 26-10 44z"></path>
              </svg>
              <span className="thq-body-small">‪+91 95004 15412‬</span>
            </div>
            <div className="contact-form3-row3 thq-flex-row">
              <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                <path d="M512 0c-176.732 0-320 143.268-320 320 0 320 320 704 320 704s320-384 320-704c0-176.732-143.27-320-320-320zM512 512c-106.040 0-192-85.96-192-192s85.96-192 192-192 192 85.96 192 192-85.96 192-192 192z"></path>
              </svg>
              <span className="thq-body-small contact-form3-address">
                Plot No.352, Panneer Nagar,4th Cross Street, Mogappair,. Chennai
                - 600 037
              </span>
            </div>
          </div>
        </div>
        <div className="contact-form3-content1 thq-flex-column">
          <div className="contact-form3-section-title thq-card">
            <div className="contact-form3-content2">
              <h2 className="thq-heading-2">
                {props.heading1 ?? (
                  <Fragment>
                    <span className="contact-form3-text7">Contact us</span>
                  </Fragment>
                )}
              </h2>
              <span>
                {props.text ?? (
                  <Fragment>
                    <span className="contact-form3-text6">
                      We&apos;re here to help you find the property of your
                      dreams. Reach out today!
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <form className="thq-card">
            <div className="contact-form3-input1">
              <label htmlFor="contact-form-3-name" className="thq-body-small">
                Name
              </label>
              <input
                type="text"
                id="contact-form-3-name"
                placeholder="Name"
                className="thq-input"
              />
            </div>
            <div className="contact-form3-input2">
              <label htmlFor="contact-form-3-email" className="thq-body-small">
                Email
              </label>
              <input
                type="email"
                id="contact-form-3-email"
                required="true"
                placeholder="Email"
                className="thq-input"
              />
            </div>
            <div className="contact-form3-container2">
              <label
                htmlFor="contact-form-3-message"
                className="thq-body-small"
              >
                Message
              </label>
              <textarea
                id="contact-form-3-message"
                rows="3"
                placeholder="Enter your message"
                className="thq-input"
              ></textarea>
            </div>
            <button
              type="submit"
              className="contact-form3-button thq-button-filled"
            >
              <span className="thq-body-small">
                {props.action ?? (
                  <Fragment>
                    <span className="contact-form3-text8">Submit</span>
                  </Fragment>
                )}
              </span>
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}

ContactForm3.defaultProps = {
  rootClassName: '',
  text: undefined,
  heading1: undefined,
  action: undefined,
  imageAlt1: 'image',
  contactForm3Id: '',
}

ContactForm3.propTypes = {
  rootClassName: PropTypes.string,
  text: PropTypes.element,
  heading1: PropTypes.element,
  action: PropTypes.element,
  imageAlt1: PropTypes.string,
  contactForm3Id: PropTypes.string,
}

export default ContactForm3
